/** Handle the derived Standard Events promise, not global browser rejections. */
(() => {
  'use strict';
  if (window.monoreeSelectionEventsInstalled) return;
  window.monoreeSelectionEventsInstalled = true;
  const handled = new WeakSet();
  let eventName;

  function onSelect(event) {
    if (!event.target?.matches?.('variant-selects') || !event.target.closest('product-info')) return;
    const promise = event.promise;
    if (!promise || typeof promise.catch !== 'function' || handled.has(promise)) return;
    handled.add(promise);
    // ProductSelectEvent creates a derived promise. Handling the source deferred
    // alone does not handle rejection of this promise. Keep its original state
    // and payload intact so Shopify analytics and other consumers still receive it.
    promise.catch((error) => {
      if (error?.name === 'AbortError' && error.message === 'Selection changed') return;
      // Real failures remain visible; product-info owns the error/retry UI.
      console.error('[MONOREE] Product selection failed', error);
    });
  }

  function connect() {
    const nextName = window.StandardEvents?.ProductSelectEvent?.eventName;
    if (!nextName || nextName === eventName) return;
    if (eventName) document.removeEventListener(eventName, onSelect, true);
    eventName = nextName;
    document.addEventListener(eventName, onSelect, true);
  }
  window.addEventListener('monoree:standard-events-ready', connect);
  connect();
})();
